export default __webpack_public_path__ + "static/media/text-cursor.27c5685b.svg";